import React from 'react';

const ClockRoundelIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='none' fillRule='evenodd'>
      <circle fill='#A86800' cx='16' cy='16' r='12' />
      <path
        d='M16 8.59a1 1 0 0 1 .993.883L17 9.59l-.001 6.272 4.24 2.76a1 1 0 0 1 .352 1.281l-.058.102a1 1 0 0 1-1.282.35l-.102-.057L15 16.948V9.59a1 1 0 0 1 1-1z'
        fill='#FFF'
        fillRule='nonzero'
      />
    </g>
  </svg>
);

export default ClockRoundelIcon;
